import {Box, IconButton, Image, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {AddressPin} from '@yandex-delivery/form/api/address'
import {tag2url} from '@yandex-delivery/utils'
import clsx from 'clsx'
import React from 'react'
import {DraggableProvided} from 'react-beautiful-dnd/'

import {OrderNumIcon} from '../OrderNumIcon/OrderNumIcon'
import * as styles from './DraggableRouteItem.classes'

export type Props = {
  index: number
  address: AddressPin
  isSource: boolean
  removable: boolean
  removeHandlers: (() => void)[]
  draggableProvided?: DraggableProvided
}

/** Тег иконки адреса "Откуда" */
const ADDRESS_SOURCE_ICON = 'delivery_address_source'

/** Тег иконки удаления точки */
const SUBTRACT_ICON = 'delivery_form_subtract'

/** Тег иконки переноса точки */
const SANDWITCH_ICON = 'delivery_sandwich_menu_icon'

export const DraggableRouteItem = React.memo<Props>(function DraggableRouteItem(props) {
  const {draggableProvided, index, address, isSource, removable, removeHandlers} = props

  const i18n = useI18n()

  return (
    <Box alignItems="center" justifyContent="space-between">
      <Box className={styles.pointAddress}>
        {isSource ? (
          <Image className={styles.image} height={56} src={tag2url(ADDRESS_SOURCE_ICON)} />
        ) : (
          <div className={styles.image}>
            <OrderNumIcon color="gray" num={index} />
          </div>
        )}
        <Box className={styles.pointAddress} flexDirection="column" justifyContent="center">
          <Typography color="minor" variant={address.title ? 'caption1' : 'body2'}>
            {isSource ? i18n('bdui.address.input.from', 'Откуда') : i18n('bdui.address.input.to', 'Куда')}
          </Typography>
          {address.title && (
            <Typography className={styles.truncatedText} variant="body2">
              {address.title}
            </Typography>
          )}
        </Box>
      </Box>
      {!isSource && (
        <Box className={styles.icons}>
          {removable && (
            <IconButton onPress={removeHandlers[index]} shape="circle" size="s" variant="ghost">
              <Image src={tag2url(SUBTRACT_ICON)} width={20} />
            </IconButton>
          )}

          <Box
            alignItems="center"
            className={styles.dragger}
            justifyContent="center"
            {...draggableProvided?.dragHandleProps}
          >
            <Image src={tag2url(SANDWITCH_ICON)} width={26} />
          </Box>
        </Box>
      )}
    </Box>
  )
})
